import React from 'react';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core';
import { usePaymentOptionsAnimation } from 'payment/hooks';

const styles = makeStyles(({ palette }) => ({
  bill: {
    transform: 'scaleY(0.67)',
    transformOrigin: 'center',
    fill: palette.text.primary,
  },
  circle: {
    fill: palette.success.main,
  },
  tick: {
    fill: palette.common.white,
  },
  billSelected: {
    animation: '$billSelected 1s',
    animationFillMode: 'forwards',
  },
  '@keyframes billSelected': {
    '0%': {
      transform: 'scaleY(0.67)',
    },
    '100%': {
      transform: 'scaleY(1)',
    },
  },
  billDeselected: {
    animation: '$billDeselected 1s',
    animationFillMode: 'forwards',
  },
  '@keyframes billDeselected': {
    '0%': {
      transform: 'scaleY(1)',
    },
    '100%': {
      transform: 'scaleY(0.67)',
    },
  },
  checkCircle: {
    opacity: 0,
  },
  checkCircleSelected: {
    animation: '$checkCircle 1s',
    animationFillMode: 'forwards',
  },
  '@keyframes checkCircle': {
    '0%': {
      transform: 'scale(0.4)',
      transformOrigin: 'center',
      opacity: 1,
    },

    '100%': {
      transform: 'scale(1)',
      transformOrigin: 'center',
      opacity: 1,
    },
  },
  checkCircleDeselected: {
    animation: '$checkCircleDeselected 1s',
  },
  '@keyframes checkCircleDeselected': {
    '0%': {
      transform: 'scale(1)',
      transformOrigin: 'center',
      opacity: 1,
    },

    '100%': {
      transform: 'scale(0.4)',
      transformOrigin: 'center',
      opacity: 0,
    },
  },
}));

interface PayFullBillAnimatedProps {
  isSelected: boolean;
}

const PayFullBillAnimated = ({ isSelected }: PayFullBillAnimatedProps) => {
  const classes = styles();
  const { playSelectedAnimation, playDeselectedAnimation } = usePaymentOptionsAnimation(isSelected);

  const billAnimation = classnames([classes.bill], {
    [classes.billSelected]: playSelectedAnimation,
    [classes.billDeselected]: playDeselectedAnimation,
  });

  const checkCircleAnimation = classnames([classes.checkCircle], {
    [classes.checkCircleSelected]: playSelectedAnimation,
    [classes.checkCircleDeselected]: playDeselectedAnimation,
  });

  return (
    <svg width="106" height="106" viewBox="0 0 106 106" xmlns="http://www.w3.org/2000/svg">
      <path
        className={billAnimation}
        d="M29 24L23 18V91H83V18L77 24L71 18L65 24L59 18L53 24L47 18L41 24L35 18L29 24Z"
      />
      <circle className={`${classes.circle} ${checkCircleAnimation}`} cx="53" cy="55" r="17" />
      <path
        className={`${classes.tick} ${checkCircleAnimation}`}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.4012 48.5729C63.1894 49.3467 63.201 50.613 62.4271 51.4012L51.6271 62.4012C51.2511 62.7842 50.7368 63 50.2 63C49.6632 63 49.1489 62.7842 48.7729 62.4012L44.5729 58.1234C43.799 57.3352 43.8106 56.0689 44.5988 55.2951C45.387 54.5212 46.6533 54.5329 47.4271 55.321L50.2 58.1453L59.5729 48.5988C60.3467 47.8106 61.613 47.799 62.4012 48.5729Z"
      />
    </svg>
  );
};

export default PayFullBillAnimated;
